import {createActionWithPayload} from "../../utils.actions";
import {ReferentialResource} from "../../../../components/admin/referential/ReferentialAdminRoot";

export const [uploadReferential, isUploadReferentialAction] = createActionWithPayload<{ file: FileList, type: ReferentialResource }>('UPLOAD_REFERENTIAL')
